// Минимальное количество дней для параметра month_width
const monthWidthMinimalDays = 90;

const frameScaleCoef = 0.9;

export const minDate = new Date("2022-03-01");

export const supChatLink = "https://jivo.chat/Gs9TCYjlnA";

const wbAdvertCompanies = [
  { id: 8, label: "Автоматическая РК" },
  { id: 9, label: "Аукцион" },
];

const appTypes = [
  { id: 1, label: "Сайт" },
  { id: 32, label: "Android" },
  { id: 64, label: "IOS" },
];

const wbTokenTypes = {
  1: "Контент",
  2: "Маркетплейс",
  3: "Статистика",
  4: "Аналитика",
  5: "Продвижение",
  6: "Рекомендации",
  7: "Вопросы и Отзывы",
  8: "Цены и скидки",
  9: "Чат с покупателем",
  10: "Поставки",
  11: "Возвраты",
  13: "Финансы",
};
export const wbTokenSyncTypes = {
  1: { group: "Статистика", name: "Заказы" },
  2: { group: "Статистика", name: "Поставки" },
  3: { group: "Статистика", name: "Продажи" },
  4: { group: "Статистика", name: "Склады" },
  5: { group: "Статистика", name: "Отчёт о продажах" },
  6: { group: "Аналитика", name: "Платное хранение" },
  7: { group: "Аналитика", name: "Платная приёмка" },
  8: { group: "Маркетплейс", name: "Поставки" },
  9: { group: "Маркетплейс", name: "Остатки" },
  10: { group: "Маркетплейс", name: "Сборочные задания" },
  11: { group: "Продвижение", name: "Полная статистика кампании" },
  12: { group: "Продвижение", name: "Получение кампаний" },
  13: { group: "Продвижение", name: "Статистика поисковой кампании по ключевым фразам" },
  14: { group: "Продвижение", name: "Кластеры ключевых фраз" },
  15: { group: "Продвижение", name: "Статистика по ключевым фразам для Автоматических кампаний" },
  16: { group: "Контент", name: "Список номенклатур" },
  17: { group: "Мой склад", name: "Мой склад" },
  18: { group: "Вопросы и Отзывы", name: "Список отзывов" },
  19: { group: "Цены и скидки", name: "Списки товаров" },
  20: { group: "Цены и скидки", name: "Акции" },
  23: { group: "Аналитика", name: "Воронка продаж" },
  29: { group: "Аналитика", name: "Поисковые запросы по товару (Джем)" },
  1014: { group: "Себестоимость", name: "Ozon" },
};

// !!! Не менять порядок в объекте ниже, если надо добавлять - делайте это ниже
const advTypes = {
  b: "АРК",
  c: "Аукцион",
};

// --------------------------------------------------------------------------------------
export const geoCities = [
  {
    id: 1,
    name: "Москва",
    full_name: "Москва (ЦФО)",
    region: "ЦФО (Центральном федеральном округе)",
  },
  {
    id: 2,
    name: "Санкт-Петербург",
    full_name: "Санкт-Петербург (СЗФО)",
    region: "СЗФО (Северо-Западном федеральном округе)",
  },
  {
    id: 3,
    name: "Новосибирск",
    full_name: "Новосибирск (СФО)",
    region: "СФО (Сибирском федеральном округе)",
  },
  {
    id: 4,
    name: "Хабаровск",
    full_name: "Хабаровск (ДФО)",
    region: "ДФО (Дальневосточном федеральном округе)",
  },
  {
    id: 5,
    name: "Екатеринбург",
    full_name: "Екатеринбург (УФО)",
    region: "УФО (Уральском федеральном округе)",
  },
  {
    id: 6,
    name: "Казань",
    full_name: "Казань (ПФО)",
    region: "ПФО (Приволжском федеральном округе)",
  },
  {
    id: 7,
    name: "Краснодар",
    full_name: "Краснодар (ЮФО)",
    region: "ЮФО (Южном федеральном округе)",
  },
];

export {
  monthWidthMinimalDays,
  frameScaleCoef,
  wbAdvertCompanies,
  appTypes,
  wbTokenTypes,
  advTypes,
};
